{
	"actions": {
		"cancel": "Cancel",
		"change_email": "Correct the address and resend",
		"change_role": "Change their role",
		"deactivate": "Deactivate their access",
		"open_menu": "Open the actions menu",
		"reactivate": "Reactivate their access",
		"remove": "Remove from the organization",
		"resend": "Resend the invitation",
		"resend_cooldown_one": "Resend in {{count}}s",
		"resend_cooldown_other": "Resend in {{count}}s",
		"revoke": "Revoke the invitation",
		"sending": "Sending…",
		"set_quota": "Change quota",
		"view_audit": "View this person's activity"
	},
	"change_email": {
		"already_active": "Nothing was changed: this person has already activated their access, and from that moment the address belongs to their account.",
		"description": "The invitation was sent to {{email}}. It will go to the new address and the previous link will stop working.",
		"new_email": "New address",
		"sent": "The invitation was sent again to {{email}}.",
		"submit": "Correct and resend",
		"title": "Correct the invitation's address"
	},
	"change_role": {
		"confirm": "Change role",
		"done": "{{name}}'s role is now {{role}}.",
		"pending": "Changing…",
		"role": "Role",
		"title": "Change {{name}}'s role?"
	},
	"channel": {
		"pending": "The live connection did not close, though, and the retry is queued: until it lands, this person keeps receiving events.",
		"pending_within": "The live connection did not close, though, and the retry is queued: until it lands, this person keeps receiving events, for at most {{window}}."
	},
	"columns": {
		"actions": "Actions",
		"email": "Email",
		"invitation": "Invitation",
		"last_activity": "Last activity",
		"name": "Name",
		"role": "Role",
		"status": "Status",
		"storage": "Storage"
	},
	"deactivate": {
		"confirm": "Deactivate their access",
		"description": "They won't be able to sign in and their open sessions will close. You can reactivate access at any time.",
		"done": "Access deactivated.",
		"done_sessions_one": "Access deactivated, {{count}} session closed.",
		"done_sessions_other": "Access deactivated, {{count}} sessions closed.",
		"pending": "Deactivating…",
		"reason": "Reason (optional)",
		"reason_help": "Kept in the activity log. {{name}} can't see it.",
		"title": "Deactivate {{name}}'s access?"
	},
	"empty": {
		"description": "Invite your team: they appear here as \"Invited\" until they finish activating their account.",
		"no_matches_description": "Nobody matches the current search or filters. Try removing one.",
		"no_matches_title": "No results",
		"title": "Nobody to show yet"
	},
	"filters": {
		"role": "Role",
		"status": "Status"
	},
	"invitation": {
		"expired": "Expired on {{date}}",
		"expires": "Expires on {{date}}",
		"sent": "Sent on {{date}}"
	},
	"invite": {
		"action": "Invite",
		"description": "We'll send an email with a link to join the organization.",
		"email": "Email",
		"email_invalid": "This is not a valid email address.",
		"email_placeholder": "name@example.com",
		"email_required": "The email address is required.",
		"language": "Invitation language",
		"quota_required": "A quota greater than zero is required.",
		"role": "Role",
		"sent": "The invitation was sent to {{email}}.",
		"submit": "Invite person",
		"title": "Invite a new person"
	},
	"last_activity": {
		"never": "Never"
	},
	"no_value": "Not available",
	"owner": {
		"locked_helper": "Organization owner: changed only from the backoffice",
		"role": "Owner"
	},
	"page_title": "People",
	"reactivate": {
		"confirm": "Reactivate their access",
		"description": "They'll be able to sign in again, with the same role and shares. They'll need to sign in again on their devices.",
		"done": "Access reactivated.",
		"pending": "Reactivating…",
		"title": "Reactivate {{name}}'s access?"
	},
	"refusal": {
		"already_invited": "This address already has an invitation waiting. Use “Resend the invitation” on that person's row rather than issuing a second one.",
		"already_member": "This address already belongs to somebody in the organization.",
		"closed": "This invitation was replaced or closed. Reload the page: if the person has a newer invitation waiting, use that one. If not, invite the address again.",
		"last_administrator": "The organization needs at least one administrator.",
		"not_administrator": "This needs the organization administrator role, and yours is not that right now. Reload the page.",
		"not_queued": "The message could not be queued for sending: nothing was sent and the previous invitation still works. You can try again right away.",
		"not_queued_database": "The invitation could not be saved: nothing was sent and the previous invitation still works. You can try again right away.",
		"not_queued_identity": "The sign-in service did not respond: nothing was sent and the previous invitation still works. You can try again right away.",
		"owner_protected": "This person is an owner of the organization and cannot be changed, deactivated or removed from here.",
		"person_not_found": "This row is no longer valid: the person is not in the list any more, and the list has just been reloaded.",
		"person_removed": "This person has already been removed from the organization.",
		"quota_pool_exceeded": "The organization does not have enough space left for this.",
		"quota_pool_exceeded_at_most": "The organization does not have enough space: you can give this person at most {{available}}.",
		"same_address": "The invitation had already been sent to this address.",
		"throttled_one": "One message a minute per address. Try again in {{count}} second.",
		"throttled_other": "One message a minute per address. Try again in {{count}} seconds.",
		"throttled_soon": "One message a minute per address. Try again shortly."
	},
	"remove": {
		"confirm": "Remove from the organization",
		"description": "They'll lose access and their open sessions will close. Their shares stay active and their activity stays in the log. They'll need a new invitation to come back.",
		"done": "Removed from the organization.",
		"done_sessions_one": "Removed from the organization, {{count}} session closed.",
		"done_sessions_other": "Removed from the organization, {{count}} sessions closed.",
		"last_owner_title": "Removing them would leave something with no owner",
		"pending": "Removing…",
		"title": "Remove {{name}} from the organization?"
	},
	"resend": {
		"already_active": "Nothing was sent: this person has already activated their access.",
		"confirm": "Resend the invitation",
		"description": "A new email will be sent. The previous link will stop working.",
		"sent": "The invitation was sent again to {{email}}.",
		"title": "Resend the invitation to {{email}}?"
	},
	"revoke": {
		"already_active": "Nothing was revoked: this person has already activated their access, and ending the access of somebody already in is a different action.",
		"confirm": "Revoke the invitation",
		"description": "The invitation link will stop working. A new invitation is needed to let them in.",
		"done": "The invitation was revoked.",
		"done_with_grants_one": "The invitation was revoked. Access to {{count}} shared item they had been given in advance was taken back as well.",
		"done_with_grants_other": "The invitation was revoked. Access to {{count}} shared items they had been given in advance was taken back as well.",
		"last_owner_description_one": "This person is the only owner of {{count}} shared item. Give it another owner and try again: nothing was changed.",
		"last_owner_description_other": "This person is the only owner of {{count}} shared items. Give each of them another owner and try again: nothing was changed.",
		"last_owner_title": "Revoking would leave something with no owner",
		"pending": "Revoking…",
		"title": "Revoke {{email}}'s invitation?"
	},
	"role": {
		"member": "Member",
		"org_admin": "Administrator"
	},
	"role_description": {
		"member": "Uploads, organizes and shares their own files.",
		"org_admin": "Manages the organization: people, sessions, shared links and settings. Also uses Drive."
	},
	"search_placeholder": "Search by name or email",
	"set_quota": {
		"amount": "Quota",
		"available": "Available to assign: {{available}}",
		"back": "Back",
		"choice": "Quota",
		"confirm": "Lower quota",
		"confirm_description": "They already use {{used}}. With a quota of {{quota}} they cannot upload until they delete enough.",
		"confirm_title": "Lower {{name}}'s quota?",
		"description": "In use: {{used}}, bin included.",
		"done": "{{name}}'s quota is now {{quota}}.",
		"done_unlimited": "{{name}}'s quota now has no limit.",
		"pending": "Saving…",
		"save": "Save",
		"title": "Quota for {{name}}",
		"too_large": "You can assign at most {{max}}."
	},
	"status": {
		"active": "Active",
		"deactivated": "Deactivated",
		"invited": "Invited",
		"removed": "Removed"
	},
	"storage": {
		"full": "full",
		"near": "nearly full",
		"no_limit": "No limit",
		"pool_over": "People are assigned more space than the organization has: you can only lower assignments.",
		"used_of": "{{used}} of {{quota}}",
		"used_unlimited": "{{used}} · no limit"
	},
	"storage_pool": {
		"assigned": "Assigned to people",
		"bar": "{{used}} in use, {{reserved}} assigned and not yet used, {{free}} left to assign, out of {{quota}}",
		"button_label": "Storage:",
		"free": "Left to assign",
		"full": "The organization is out of space: nobody can upload until some is freed up.",
		"limit": "Quota",
		"near": "{{free}} left before the organization is out of space.",
		"quota": "Organization quota",
		"reserved": "Assigned, not yet used",
		"unavailable": "The organization's storage could not be read.",
		"used": "In use"
	},
	"total_one": "{{count}} person",
	"total_other": "{{count}} people",
	"window": {
		"hours_one": "one hour",
		"hours_other": "{{count}} hours",
		"minutes_one": "one minute",
		"minutes_other": "{{count}} minutes",
		"seconds_one": "one second",
		"seconds_other": "{{count}} seconds"
	}
}
